import React, { useEffect, useRef } from "react";

export default function LoginBridge() {
  const receivedRef = useRef(false);

  useEffect(() => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("domain");
    localStorage.removeItem("domain_type");
    localStorage.removeItem("master_login");
    localStorage.removeItem("business_account_details");

    function handler(event) {
      const adminOrigin = getPermittedDomain();
      if (event.origin !== adminOrigin) return;

      const data = event.data;
      if (!data || data.type !== "MERCHANT_AUTO_LOGIN") return;
      if (receivedRef.current) return;
      receivedRef.current = true;

      try {
        if (event.source) {
          event.source.postMessage({ type: "MERCHANT_LOGIN_ACK" }, event.origin);
        }

        localStorage.setItem("auth_token", data.auth_token);
        localStorage.setItem("master_login", JSON.stringify(data.master_login));
        localStorage.setItem("business_account_details", JSON.stringify(data.business_account_details));
        localStorage.setItem("domain", JSON.stringify(data.domain));
        localStorage.setItem("domain_type", JSON.stringify(data.domain_type));

        const domain = data.domain;
        if (domain && domain.id) {
          window.location.href = `/business/${domain.id}/home`;
        } else {
          console.error("Domain info missing in LoginBridge data:", data);
          window.location.href = "/login";
        }
      } catch (err) {
        console.error("Error handling LoginBridge data:", err);
        window.location.href = "/login";
      }
    }

    window.addEventListener("message", handler);

    const timer = setTimeout(() => {
      if (!receivedRef.current) {
        console.warn("Auto-login timeout — redirecting to /login");
        window.location.href = "/login";
      }
    }, 10000);

    return () => {
      window.removeEventListener("message", handler);
      clearTimeout(timer);
    };
  }, []);

  return <div style={{ padding: 40 }}>Logging you in…</div>;
}

function getPermittedDomain() {
    var permittedDomain = window.location.hostname === "seated-merchant.firebaseapp.com" || window.location.hostname === "seatedrestaurants.io" || window.location.hostname === "www.seatedrestaurants.io"
                            ? "https://portal.seatedapp.io" :
                            window.location.hostname === 'seated-merchant-staging.firebaseapp.com' || window.location.hostname === 'seated-merchant-staging.web.app' ?
                            "https://portal.staging.seatedapp.io" :
                            "https://seated-portal-uat.seatedapp.io";
    return permittedDomain;
}
